module.exports = __webpack_public_path__ + "img/temperature.e5080bdd.svg";